import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ticket-sub-type',
  templateUrl: './ticket-sub-type.component.html',
  styleUrls: ['./ticket-sub-type.component.css']
})
export class TicketSubTypeComponent implements OnInit {

  model= false;
  data:any = []
  isedit= false;
  name="";
  version="";
  remarks="";
  i = 0
  deleteId: any = "";
  cid:any

  
  isLoading: any = false
  editForm: any | FormGroup
  ticketsubtypeId: any
  ticketsubtypeData: any



actionControls: any = {
  isAdd: false, 
  isView: false, 
  isDelete: false, 
  isModify: false 
}

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  sub_ticket:any = []

  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  
  ngOnInit(): void {
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action
    
    this.cid = sessionStorage.getItem('cid')
    // this.getAllSubTickets()
    this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)

    this.editForm = this.fb.group({
      name: [''],
      remarks: [''],
      version: [''],
    });

    this.form = this.fb.group({
      name: [''],
      remarks: [''],
      version: [''],
    });
  }

  addSubticket(){

    let body = {
      "version": Number(this.form.get('version').value),
      "isActive": true,
      "description": "",
      "name": String(this.form.get('name').value),
      "remarks": String(this.form.get('remarks').value),
      "displayOrder": "",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addSubTicket(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);

      }
    )
  }
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
  }

  // getAllSubTickets(){
  //   this.isLoading = true

  //   this.generic_service.getAllSubTickets().subscribe(
  //     (response:any)=>{
  //       this.sub_ticket = response.response;
  //       this.count = response.response.length;
  //       console.log(response)
  //       this.isLoading = false
  //     }
  //   )
  // }

  editskill(){
    this.data[this.i].name=this.name
    this.data[this.i].version=this.version
    this.data[this.i].remarks=this.remarks
    this.close()
  }
  open() {
    this.model = true;
  }
  close() {
    this.model = false;
    this.name = "";
    this.version = "";
    this.remarks = "";
     
  }
  
  edit(i:any){
    this.open();
    this.name = this.data[i].name;
    this.version = this.data[i].version ;
    this.remarks = this.data[i].remarks ;
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.pageNumber = event.page;

    if(this.searchKey != ""){
      this.getTicketSubTypeByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)
    }

  }

  delSubTicket(){
    this.generic_service.delTicketSubType(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  getTicketSubTypeById(id:any){
    this.ticketsubtypeId = id
    this.generic_service.getTicketSubTypeById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.ticketsubtypeData = response.response
        this.editForm.patchValue({
          name: response.response.name,
          version: response.response.version,
          remarks: response.response.remarks,
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  updateTicketSubType(){

    let body = {
      "version": Number(this.editForm.get('version').value),
      "isActive": true,
      "description": "",
      "id": this.ticketsubtypeData.id,
      "typeId": 0,
      "ticketSubTypeId": this.ticketsubtypeId,
      "name": String(this.editForm.get('name').value),
      "remarks": String(this.editForm.get('remarks').value),
      "displayOrder": "",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.updateTicketSubType(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);

      }
    )
  }


  getAllTicketSubTypeWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllTicketSubTypeWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.sub_ticket = response.response.ticketSubTypeList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      }
    )
  }


  getTicketSubTypeByWildSearch(pageNumber: any,recordsPerPage: any){
    if(this.searchKey != ""){
      this.isLoading = true
  
      this.generic_service.getTicketSubTypeByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.sub_ticket = response.response.ticketSubTypeList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false
  
        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }
  
  refreshSearch(){
    this.searchKey = ""
    this.getAllTicketSubTypeWithPagination(this.pageNumber,this.recordsPerPage)
  }
}
